import React from "react";
import propTypes from "prop-types";
import styled from "styled-components";
import { space, layout } from "styled-system";

const StyledSpan = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 2px solid ${({ checked }) => (checked ? "#D0004B" : "#D9DBE9")};
  border-radius: 4px;
  background-color: ${({ checked }) => (checked ? "#D0004B" : "white")};
  cursor: pointer;
  position: relative;

  width: ${({ width }) => width || "24px"};
  height: ${({ height }) => height || "24px"};

  &::after {
    content: "";
    position: absolute;
    display: ${({ checked }) => (checked ? "block" : "none")};
    left: calc(50% - 3px);
    top: calc(50% - 6px);
    width: 6px;
    height: 12px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }

  ${space}
  ${layout}
`;

const Checkbox = ({
  type,
  checked,
  disabled,
  onChange,
  height,
  width,
  ...props
}) => {
  const handleClick = () => {
    if (onChange && !disabled) {
      onChange(!checked);
    }
  };

  if (type === "radio") {
    return null; // or handle radio type separately
  }

  return (
    <StyledSpan
      {...props}
      onClick={handleClick}
      checked={checked}
      width={width}
      height={height}
      data-testid={type}
      data-value={checked}
    />
  );
};

Checkbox.propTypes = {
  onChange: propTypes.func,
  type: propTypes.oneOf(["checkbox", "switch", "radio"]),
  checked: propTypes.bool.isRequired,
  disabled: propTypes.bool,
  height: propTypes.oneOfType([propTypes.string, propTypes.number]),
  width: propTypes.oneOfType([propTypes.string, propTypes.number]),
};

Checkbox.defaultProps = {
  onChange: null,
  disabled: false,
  type: "checkbox",
  height: "24px",
  width: "24px",
};

export default Checkbox;
